<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">业务系统：</span>
        </div>
        <el-input v-model="formData.parentName" size="small" style="width: 280px" :maxlength="64" disabled />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">消息类型：</span>
        </div>
        <el-input v-model="formData.eventName" size="small" style="width: 280px" :maxlength="64" disabled />
      </div>

      <div class="form-line" >
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">消息模板：</span>
        </div>
        <el-select v-model="formData.templateId"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="templateRemoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in templateList" :key="item.templateId"
                     :label="item.title" :value="item.templateId">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">
            可选模板标语<el-tooltip class="item" effect="dark" content="模板标语可复制粘贴至消息内容，消息发送时系统会自动替换相应内容" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>：
          </span>
        </div>
        <el-tag v-for="item in dynamicTextArr" :key="item" class="copyButton" style="margin-right: 10px;cursor: pointer" :data-clipboard-text="item" @click="copy">{{item}}</el-tag>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">副标题：</span>
        </div>
        <el-input v-model="formData.first" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-line" v-if="templateData.keyword1">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">{{templateData.keyword1}}：</span>
        </div>
        <el-input v-model="formData.keyword1" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-line" v-if="templateData.keyword2">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">{{templateData.keyword2}}：</span>
        </div>
        <el-input v-model="formData.keyword2" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-line" v-if="templateData.keyword3">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">{{templateData.keyword3}}：</span>
        </div>
        <el-input v-model="formData.keyword3" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-line" v-if="templateData.keyword4">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">{{templateData.keyword4}}：</span>
        </div>
        <el-input v-model="formData.keyword4" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-line" v-if="templateData.keyword5">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">{{templateData.keyword5}}：</span>
        </div>
        <el-input v-model="formData.keyword5" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.remark" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-line">
        <div class="textBox">
<!--          <b class="red">*</b>-->
          <span class="line-text">推送人员：</span>
        </div>
        <el-select v-model="personCode" multiple size="small" style="width: 280px" filterable remote reserve-keyword :remote-method="remoteMethod2" placeholder="请输入关键字搜索">
          <el-option v-for="item in personList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

<!--      <div class="form-line" v-if="formData.detail.indexOf('balance') !== -1">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">余额：</span>-->
<!--        </div>-->
<!--        <el-input-number controls-position="right" v-model="balance" size="small" style="width: 280px" :maxlength="64" />-->
<!--      </div>-->

      <div class="form-line" v-if="formData.detail.indexOf('remainingDays') !== -1">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">到期前天数：</span>
        </div>
        <el-input-number controls-position="right" v-model="remainingDays" size="small" style="width: 280px" :maxlength="64" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import $ from "jquery";
import { api } from "../../api/Message";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
import UploadImgList from "../../../components/Input/UploadImgList";
import Clipboard from "clipboard";

export default {
  components: {
    UploadImgList,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "message-push-modify",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧消息",
          name: "message-template-manage"
        },
        {
          value: "消息推送配置"
        }
      ],
      mainTitle: "修改消息推送配置",
      subheading: "",

      formData: {
        templateId: "",
        keyword1: "",
        keyword2: "",
        keyword3: "",
        keyword4: "",
        keyword5: "",
        remark: ""
      },

      templateList: [],

      templateData: {},

      dynamicTextArr: [],

      personCode: "",
      personList: [],
      balance: "",
      remainingDays: ""
    };
  },
  created() {
    this.templateRemoteMethod();
    this.getWxPushConfigByCode(this.$route.params.id);
    // this.getResponsiblePersonList()
    this.remoteMethod2();
  },
  methods: {
    templateRemoteMethod(query) {
      this.getWxTemplateList(query);
    },
    // 查询模板列表
    getWxTemplateList(query) {
      this.$axios
        .post(`${api.getWxTemplateList}`, {
          searchKey: query || ""
        })
        .then(res => {
          if (res.data.retCode === 1) {
            this.templateList = res.data.data;
          }
        })
        .catch(errorHandler("查询失败"));
    },
    // 查询配置
    getWxPushConfigByCode(code) {
      this.$axios
        .get(`${api.getWxPushConfigByCode}/${code}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let resData = res.data.data;
            this.formData = resData;
            this.formData.detail = resData.detail || "";
            if (this.formData.detailMap) {
              this.personCode = this.formData.detailMap.responsiblePersonCode;
            } else {
              this.formData.detailMap = {};
            }
            if (this.formData.detail) {
              if (this.formData.detail.indexOf("balance") !== -1) {
                this.balance = this.formData.detailMap.balance;
              } else if (this.formData.detail.indexOf("remainingDays") !== -1) {
                this.remainingDays = this.formData.detailMap.remainingDays;
              }
            }
            this.getWxTemplateById(this.formData.templateId);
            this.getWxEventConfigByCode(this.formData.eventCode);
          }
        })
        .catch(errorHandler("查询失败"));
    },

    // 查询消息模板
    getWxTemplateById(templateId) {
      this.$axios
        .post(`${api.getWxTemplateById}`, {
          templateId
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let resData = res.data.data;
            this.templateData = resData;
          }
        })
        .catch(errorHandler("查询失败"));
    },

    // 查询类型详情
    getWxEventConfigByCode(eventCode) {
      this.$axios
        .get(`${api.getWxEventConfigByCode}/${eventCode}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let resData = res.data.data;
            if (resData.dynamicText) {
              let dynamicTextArr = resData.dynamicText.split(",");
              dynamicTextArr.map((v, i) => {
                dynamicTextArr[i] = `&{${v}}`;
              });
              this.dynamicTextArr = dynamicTextArr;
            }
          }
        })
        .catch(errorHandler("查询失败"));
    },

    remoteMethod2(query) {
      this.getResponsiblePersonList(query);
    },

    // 获取人员列表
    getResponsiblePersonList(searchKey) {
      this.$axios
        .post(api.getResponsiblePersonList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            this.personList = res.data.data;
          }
        })
        .catch(errorHandler("获取人员列表失败"));
    },

    toManagePage() {
      this.$router.push({
        name: "message-push-config"
      });
    },

    confirm() {
      if (!this.formData.first) {
        nError("请输入副标题");
        return false;
      }
      if (this.templateData.keyword1 && !this.formData.keyword1) {
        nError(`请输入${this.templateData.keyword1}`);
        return false;
      }
      if (this.templateData.keyword2 && !this.formData.keyword2) {
        nError(`请输入${this.templateData.keyword1}`);
        return false;
      }
      if (this.templateData.keyword3 && !this.formData.keyword3) {
        nError(`请输入${this.templateData.keyword1}`);
        return false;
      }
      if (this.templateData.keyword4 && !this.formData.keyword4) {
        nError(`请输入${this.templateData.keyword1}`);
        return false;
      }
      if (this.templateData.keyword5 && !this.formData.keyword5) {
        nError(`请输入${this.templateData.keyword1}`);
        return false;
      }
      if (!this.formData.remark) {
        nError("请输入备注");
        return false;
      }
      // if (this.formData.detail.indexOf('responsiblePersonCode') !== -1) {
      //   if (this.personCode.length === 0) {
      //     nError('请选择责任人')
      //     return false
      //   } else {
      //     this.formData.detailMap = {
      //       responsiblePersonCode: this.personCode
      //     }
      //   }
      // }
      // if (this.formData.detail.indexOf('balance') !== -1) {
      //   if (!this.balance) {
      //     nError('请输入余额')
      //     return false
      //   } else {
      //     this.formData.detailMap = {
      //       balance: this.balance
      //     }
      //   }
      // }
      if (this.formData.detail.indexOf("remainingDays") !== -1) {
        if (!this.remainingDays) {
          nError("请输入到期前天数");
          return false;
        } else {
          this.formData.detailMap = {
            remainingDays: this.remainingDays
          };
        }
      }
      this.formData.detailMap.responsiblePersonCode = this.personCode;
      this.$axios
        .post(api.saveOrUpdateWxPushConfig, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.toManagePage();
          }
        })
        .catch(errorHandler("修改失败"));
    },
    cancel() {
      this.toManagePage();
    },
    copy() {
      let clipboard = new Clipboard(".copyButton");
      clipboard.on("success", e => {
        nSuccess("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        nError("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    }
  },
  watch: {
    "formData.templateId": {
      handler(newName, oldName) {
        if (oldName) {
          this.formData.keyword1 = "";
          this.formData.keyword2 = "";
          this.formData.keyword3 = "";
          this.formData.keyword4 = "";
          this.formData.keyword5 = "";
        }
        this.getWxTemplateById(this.formData.templateId);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
  vertical-align: sub;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
}
.form-line > div {
  margin-right: 20px;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 140px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 110px 0 140px;
  margin: 40px 0 0 0;
  display: flex;
  justify-content: space-between;
}
.newly2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  border: 1px dashed #d7d7d7;
  margin-right: 20px;
  position: relative;
}
.newly2 span {
  display: block;
  width: 100%;
  color: #999999;
  margin: 0;
  padding: 0;
  text-align: center;
}
.newly2 span:first-child {
  font-size: 36px;
  line-height: 120px;
  position: absolute;
  top: 15px;
}
.newly2 span:last-child {
  font-size: 14px;
  line-height: 50px;
  position: absolute;
  bottom: 0;
}
.upload2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  background-size: 100% 100%;
  position: relative;
}

.upload2 img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.upload2 b {
  display: inline-block;
  width: 100%;
  line-height: 21px;
  color: white;
  background-color: #989796;
  text-align: center;
  position: absolute;
  bottom: 0;
  opacity: 0.7;
}
</style>

<style lang="less">
.el-switch {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/MessageService/MessagePushConfig/MessagePushModify.vue